export const globalComputed = {
  computed: {
    /**
     * Add padding to module based on config
     */
    modulePadding() {
      const { paddings } = this.module.config.general;

      // Special case for the form module, as long as it does not have the setting for this
      if (!paddings && this.module.key === "module-application-form") {
        return {
          paddingTop: "var(--cr-module-padding-large)",
          paddingBottom: "var(--cr-module-padding-large)",
        };
      }

      return {
        paddingTop: paddings.top
          ? "var(--cr-module-padding-large)"
          : "var(--cr-module-padding-small)",
        paddingBottom: paddings.bottom
          ? "var(--cr-module-padding-large)"
          : "var(--cr-module-padding-small)",
      };
    },
    /**
     * Nested modules (used in Slider and Gallery) shouldn't have padding
     */
    nestedModulePadding() {
      if (this.isNestedModule || this.isSliderModule) {
        return {
          paddingTop: 0,
          paddingBottom: 0,
        };
      } else {
        return {};
      }
    },
  },
};

export const globalMethods = {
  methods: {
    /**
     * Append CDN modification parameters to a given image url.
     *
     * @param imageUrl
     * @param width
     * @return {string}
     */
    appendCdnParams(imageUrl, width = null) {
      try {
        let modifiedImageUrl = new URL(imageUrl);
        modifiedImageUrl.searchParams.append("format", "webp");

        if (width) {
          // Set width for image
          modifiedImageUrl.searchParams.append("width", width);
          // Make sure it does not get enlarged beyond its original dimensions
          modifiedImageUrl.searchParams.append("enlarge", "0");
        }

        return modifiedImageUrl.href;
      } catch (e) {
        console.log("Not a valid image url: ", imageUrl, e);
        return "";
      }
    },
    /**
     * Returns list of image sizes for the sizes attribute based on the provided widths
     *
     * @param mobileWidth
     * @param tabletWidth
     * @param laptopWidth
     * @param desktopWidth
     * @returns {string}
     */
    setImageSizes(mobileWidth, tabletWidth, laptopWidth, desktopWidth) {
      return `(max-width: 733px) ${mobileWidth}w, (max-width: 1033px) ${tabletWidth}w, (max-width: 1600px) ${laptopWidth}w), (min-width: 1601px) ${desktopWidth}w)`;
    },
    /**
     * Returns list of image sources for the srcset attribute based on the provided widths.
     * Provided widths are multiplied by 1.5 for the image to avoid low resolutions on high DPI screens.
     *
     * @param imageUrl
     * @param mobileWidth
     * @param tabletWidth
     * @param laptopWidth
     * @param desktopWidth
     * @returns {string}
     */
    setImageSrcSet(
      imageUrl,
      mobileWidth,
      tabletWidth,
      laptopWidth,
      desktopWidth,
    ) {
      const widthMultiplier = 1.5;

      return `
        ${this.appendCdnParams(
          imageUrl,
          mobileWidth * widthMultiplier,
        )} ${mobileWidth}w,
        ${this.appendCdnParams(
          imageUrl,
          tabletWidth * widthMultiplier,
        )} ${tabletWidth}w,
        ${this.appendCdnParams(
          imageUrl,
          laptopWidth * widthMultiplier,
        )} ${laptopWidth}w,
        ${this.appendCdnParams(
          imageUrl,
          desktopWidth * widthMultiplier,
        )} ${desktopWidth}w,
      `;
    },
    /**
     * Evaluates the config.general.showHeader property or returns true if it is not set, to be backwards compatible
     */
    showHeader(module) {
      return module.config.general.showHeader !== undefined
        ? module.config.general.showHeader
        : true;
    },
  },
};
